export default __webpack_public_path__ + "static/media/Team2.a43463b3.png";